<template>
  <section class="dp-layout tr-page tg-page">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="handleNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <header class="tg-hero">
        <div>
          <p class="tg-eyebrow">集体备课 · 基础配置</p>
          <h1 class="tg-title">教研组管理</h1>
          <p class="tg-sub">维护教研组、教师与课本目录，为 H5 备课流程打底。</p>
        </div>
        <div class="tg-hero__stat">
          <span>本组数</span>
          <strong>{{ total }}</strong>
        </div>
      </header>

      <div class="tg-panel">
        <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

                <!-- 列表：tbl-scroll-host + height 表体占满、空状态可见。最后更新：2026-08-31 -->
                <div class="tbl-scroll-host">
                <el-table height="100%"
          :data="tableData"
          v-loading="listLoading"
          @select="dialogCheck"
          @row-click="selectCurrentRow"
          ref="table"
          class="tg-table"
          style="width: 100%"
        >
          <el-table-column type="selection" width="50" />
          <el-table-column prop="GroupName" label="教研组名称" min-width="120">
            <template slot-scope="scope">
              <span class="tg-name">{{ scope.row.GroupName || scope.row.groupName || "—" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="课本册" width="90" align="center">
            <template slot-scope="scope">
              <span class="tg-count">{{ scope.row.TextbookCount != null ? scope.row.TextbookCount : 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="通过阈值" width="90" align="center">
            <template slot-scope="scope">{{ scope.row.VotePassPercent || 60 }}%</template>
          </el-table-column>
          <el-table-column label="教研组教师" min-width="140">
            <template slot-scope="scope">
              <span
                v-if="(scope.row.TeacherNames || scope.row.teacherNames || []).length"
                class="multi-teacher-tag"
                @click="openTeacherDialog(scope.row)"
              >
                <template v-if="(scope.row.TeacherNames || scope.row.teacherNames).length <= 2">
                  {{ (scope.row.TeacherNames || scope.row.teacherNames).join('、') }}
                </template>
                <template v-else>
                  {{ (scope.row.TeacherNames || scope.row.teacherNames).slice(0, 2).join('、') }} 等 {{ (scope.row.TeacherNames || scope.row.teacherNames).length }} 人
                </template>
                <i class="el-icon-view"></i>
              </span>
              <span v-else class="text-gray">未设置</span>
            </template>
          </el-table-column>
          <el-table-column label="有效时间" width="200">
            <template slot-scope="scope">
              {{ formatDate(scope.row.StartTime) }} 至 {{ formatDate(scope.row.EndTime) }}
            </template>
          </el-table-column>
          <el-table-column label="匿名评价" width="90" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.IsAnonymousReview ? 'success' : 'info'" size="mini">
                {{ scope.row.IsAnonymousReview ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="评语阈值" width="90" align="center">
            <template slot-scope="scope">
              <span class="tg-threshold">{{ scope.row.CommentThreshold || 15 }}</span>
              <span class="tg-unit">字</span>
            </template>
          </el-table-column>
          <el-table-column label="归档状态" width="90" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.IsHistory ? 'danger' : 'success'" size="mini">
                {{ scope.row.IsHistory ? '已归档' : '进行中' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.Status"
                :active-value="0"
                :inactive-value="1"
                @change="handleStatusChange(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250" align="center">
            <template slot-scope="scope">
              <div class="table-op-pair">
                <el-button type="text" size="small" class="table-op-link" @click="openCatalog(scope.row)">维护课本与目录</el-button>
                <el-button type="text" size="small" class="table-op-link" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button type="text" size="small" class="table-op-link table-op-link--danger" @click="handleDel(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
                </div>

        <div class="tg-pager">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="filters.Page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="filters.PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </div>

      <!-- 维护目录弹窗 -->
      <el-dialog
        :visible.sync="catalogVisible"
        width="1180px"
        top="4vh"
        append-to-body
        :close-on-click-modal="false"
        custom-class="tag-catalog-dilog"
        @closed="onCatalogClosed"
      >
        <div slot="title" class="tg-dialog-title">
          <span class="tg-dialog-title__mark"></span>
          <div>
            <div class="tg-dialog-title__main">维护课本与目录</div>
            <div class="tg-dialog-title__sub">{{ catalogGroupName || '教研组' }}</div>
          </div>
        </div>
        <PrepCatalog
          v-if="catalogVisible && catalogGroupId"
          :group-id="catalogGroupId"
          :group-name="catalogGroupName"
          :school-id="SchoolId"
          :group-teacher-ids="catalogTeacherIds"
        />
      </el-dialog>

      <!-- 新增/编辑弹窗 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="600px"
        custom-class="tg-edit-dialog"
        @close="resetForm"
      >
        <el-form :model="editForm" :rules="formRules" ref="editForm" label-width="120px" size="small">
          <el-form-item label="教研组名称" prop="GroupName">
            <el-input v-model="editForm.GroupName" placeholder="请输入教研组名称"></el-input>
          </el-form-item>
          <el-form-item label="同意达到">
            <el-input-number v-model="editForm.VotePassPercent" :min="1" :max="100"></el-input-number>
            <span class="form-hint">%（通过后可发布公共库）</span>
          </el-form-item>
          <el-form-item label="有效时间" prop="dateRange">
            <el-date-picker
              v-model="editForm.dateRange"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="教研组教师" prop="TeacherIds">
            <el-select
              v-model="editForm.TeacherIds"
              multiple
              filterable
              placeholder="请选择教研组教师"
              style="width: 100%"
              :loading="teacherLoading"
            >
              <el-option v-for="item in teacherOptions" :key="item.Id" :label="item.TeacherName" :value="item.Id" />
            </el-select>
            <div class="form-tip">
              <i class="el-icon-info"></i>
              <span>支持多选，可输入姓名搜索。</span>
            </div>
          </el-form-item>
          <el-form-item label="启用匿名评价">
            <el-switch v-model="editForm.IsAnonymousReview"></el-switch>
            <div class="form-tip">
              <i class="el-icon-info"></i>
              <span>开启后，教师在互评时将隐藏上传老师的姓名。</span>
            </div>
          </el-form-item>
          <el-form-item label="有效评语阈值">
            <el-input-number v-model="editForm.CommentThreshold" :min="1" :max="1000" label="字数"></el-input-number>
            <span class="form-hint">字数超过此值才计入有效评语</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" class="tg-btn-primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 教研组教师名单弹窗 -->
      <el-dialog
        :visible.sync="teacherDialogVisible"
        width="480px"
        append-to-body
        custom-class="tg-teacher-dialog"
      >
        <div slot="title" class="tg-dialog-title">
          <span class="tg-dialog-title__mark"></span>
          <div>
            <div class="tg-dialog-title__main">教研组教师</div>
            <div class="tg-dialog-title__sub">
              {{ teacherDialogGroupName || "教研组" }}
              · 共 {{ teacherDialogNames.length }} 人
            </div>
          </div>
        </div>
        <div v-if="teacherDialogNames.length" class="tg-teacher-grid">
          <span v-for="(name, idx) in teacherDialogNames" :key="idx" class="tg-teacher-chip">{{ name }}</span>
        </div>
        <div v-else class="text-gray">暂无教师</div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" class="tg-btn-primary" @click="teacherDialogVisible = false">关 闭</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import { getTeachingGroupPage, saveTeachingGroup, changeTeachingGroupStatus, deleteTeachingGroup, exportTeachingGroup, getPrepSchoolConfig } from '../../api/modules/teaching-research';
import { getTeacherMasterList } from '../../api/modules/personnel';
import { getButtonList } from "@/promissionRouter";
import Toolbar from "@/components/Toolbar";
import DepartmentPane from "@/components/DepartmentPane";
import PrepCatalog from "./PrepCatalog.vue";
import util from "@/../util/date";
import { normalizeDeptId } from "@/utils/deptCascaderProps";

export default {
  name: "TeachingGroup",
  components: { Toolbar, DepartmentPane, PrepCatalog },
  data() {
    return {
      filters: {
        Page: 1,
        PageSize: 10,
        Keyword: "",
        Status: null
      },
      tableData: [],
      total: 0,
      listLoading: false,
      buttonList: [],
      currentRow: null,
      catalogVisible: false,
      catalogGroupId: 0,
      catalogGroupName: "",
      catalogTeacherIds: [],
      teacherDialogVisible: false,
      teacherDialogGroupName: "",
      teacherDialogNames: [],
      searchList: [
        { label: "教研组名称", key: "Keyword", type: "input", placeholder: "关键词模糊查询", initValue: "" },
        { label: "状态", key: "Status", type: "select", width: '120px', options: [{ label: "全部", value: null }, { label: "可用", value: 0 }, { label: "禁用", value: 1 }], initValue: null }
      ],
      // 弹窗相关
      dialogVisible: false,
      dialogTitle: "新增教研组",
      submitLoading: false,
      editForm: {
        Id: 0,
        GroupName: "",
        VotePassPercent: 60,
        dateRange: [],
        IsAnonymousReview: false,
        CommentThreshold: 15,
        Status: 0,
        TeacherIds: []
      },
      formRules: {
        GroupName: [{ required: true, message: "请输入教研组名称", trigger: "blur" }],
        dateRange: [{ required: true, message: "请选择有效时间", trigger: "change" }]
      },
      gradeOptions: [],
      teacherOptions: [],
      teacherLoading: false,
      SchoolId: null
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return "-";
      return util.formatDate.format(new Date(date), "yyyy-MM-dd");
    },
    // 获取列表
    getList() {
      if (!normalizeDeptId(this.SchoolId)) {
        this.$message({ message: "当前处于总平台状态，请先从左侧选择具体的机构/学校再进行查询", type: "error" });
        return;
      }
      this.listLoading = true;
      const params = {
        ...this.filters,
        SchoolId: this.SchoolId
      };
      getTeachingGroupPage(params)
        .then(res => {
          if (res.success) {
            this.tableData = (res.response.data || []).map(x => ({
              ...x,
              GroupName: x.GroupName || x.groupName || "",
              TeacherNames: x.TeacherNames || x.teacherNames || [],
              TeacherIds: x.TeacherIds || x.teacherIds || [],
              TextbookCount: x.TextbookCount != null ? x.TextbookCount : x.textbookCount || 0
            }));
            this.total = res.response.dataCount;
          } else {
            this.$message.error(res.msg || "获取列表失败");
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    // 加载教师
    loadTeachers(schoolId) {
      if (!schoolId || schoolId <= 0) return;
      this.teacherLoading = true;
      let para = { page: 1, intPageSize: 9999, DepartmentId: schoolId };
      getTeacherMasterList(para).then(res => {
        this.teacherLoading = false;
        if (res.data && res.data.response) {
          this.teacherOptions = res.data.response;
        } else {
          this.teacherOptions = [];
        }
      }).catch(() => {
        this.teacherLoading = false;
        this.teacherOptions = [];
      });
    },
    // 状态切换
    handleStatusChange(row) {
      const statusText = row.Status === 0 ? "启用" : "禁用";
      changeTeachingGroupStatus({ id: row.Id, status: row.Status })
        .then(res => {
          if (res.success) {
            this.$message.success(`${statusText}成功`);
          } else {
            this.$message.error(res.msg || `${statusText}失败`);
            row.Status = row.Status === 0 ? 1 : 0; // 回滚
          }
        })
        .catch(() => {
          row.Status = row.Status === 0 ? 1 : 0; // 回滚
        });
    },
    // 工具栏回调
    callFunction(item) {
      if (item.Func === "handleQuery") {
        this.filters.Page = 1;
        this.filters.Keyword = item.search.Keyword;
        this.filters.Status = item.search.Status;
        this.getList();
      } else if (item.Func === "btnAdd") {
        this.handleAdd();
      } else if (item.Func === "handleEdit") {
        this.handleEdit();
      } else if (item.Func === "handleDel") {
        this.handleDel();
      } else if (item.Func === "exportExcel") {
        this.exportExcel();
      } else if (this[item.Func]) {
        this[item.Func].apply(this, [item]);
      }
    },
    async exportExcel() {
      if (!normalizeDeptId(this.SchoolId)) {
        this.$message({ message: "请先选择学校再进行导出", type: "error" });
        return;
      }
      try {
        let para = {
          SchoolId: this.SchoolId,
          ...this.filters
        };

        const response = await exportTeachingGroup(para);
        if (!response.data) {
          this.$message.error("导出数据为空");
          return;
        }

        let fileName = "教研组列表导出.xlsx";
        const disposition = response.headers['content-disposition'];
        if (disposition) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''));
            if (fileName.toLowerCase().startsWith("utf-8''")) {
              fileName = decodeURIComponent(fileName.substring(7));
            }
          }
        }

        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        this.$message.success("导出成功");
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error("导出失败");
      }
    },
    // 复选框单选逻辑
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length > 0 && row) {
        this.selectCurrentRow(row);
      }
    },
    // 行点击选中逻辑
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    openCatalog(row) {
      if (!row || !row.Id) return;
      this.catalogGroupId = row.Id;
      this.catalogGroupName = row.GroupName || "";
      this.catalogTeacherIds = row.TeacherIds || [];
      this.catalogVisible = true;
    },
    /** 查看教研组教师名单弹窗 */
    openTeacherDialog(row) {
      if (!row) return;
      this.teacherDialogGroupName = row.GroupName || "";
      this.teacherDialogNames = (row.TeacherNames || []).slice();
      this.teacherDialogVisible = true;
    },
    onCatalogClosed() {
      this.catalogGroupId = 0;
      this.catalogGroupName = "";
      this.catalogTeacherIds = [];
    },
    // 新增
    async handleAdd() {
      if (!normalizeDeptId(this.SchoolId)) {
        this.$message({ message: "当前处于总平台状态，请先从左侧选择具体的机构/学校再进行新增", type: "error" });
        return;
      }
      this.dialogTitle = "新增教研组";
      const start = new Date();
      const end = new Date();
      end.setFullYear(start.getFullYear() + 1);
      let votePassPercent = 60;
      let commentThreshold = 15;
      try {
        const cfgRes = await getPrepSchoolConfig({ schoolId: this.SchoolId });
        if (cfgRes.success && cfgRes.response) {
          const r = cfgRes.response;
          votePassPercent = r.VotePassPercent != null ? r.VotePassPercent : (r.votePassPercent || 60);
          commentThreshold = r.DefaultCommentThreshold != null ? r.DefaultCommentThreshold : (r.defaultCommentThreshold || 15);
        }
      } catch (e) { /* 使用默认 */ }
      this.editForm = {
        Id: 0,
        GroupName: "",
        VotePassPercent: votePassPercent,
        dateRange: [util.formatDate.format(start, "yyyy-MM-dd"), util.formatDate.format(end, "yyyy-MM-dd")],
        IsAnonymousReview: false,
        CommentThreshold: commentThreshold,
        Status: 0,
        TeacherIds: []
      };
      this.loadTeachers(this.SchoolId);
      this.dialogVisible = true;
    },
    // 编辑
    handleEdit(row) {
      const target = row || this.currentRow;
      if (!target) {
        this.$message.error("请先选择一行要编辑的数据");
        return;
      }
      this.dialogTitle = "编辑教研组";
      this.editForm = {
        Id: target.Id,
        GroupName: target.GroupName,
        VotePassPercent: target.VotePassPercent || 60,
        dateRange: [util.formatDate.format(new Date(target.StartTime), "yyyy-MM-dd"), util.formatDate.format(new Date(target.EndTime), "yyyy-MM-dd")],
        IsAnonymousReview: target.IsAnonymousReview,
        CommentThreshold: target.CommentThreshold || 15,
        Status: target.Status,
        TeacherIds: target.TeacherIds || []
      };
      this.loadTeachers(this.SchoolId);
      this.dialogVisible = true;
    },
    // 删除
    handleDel(row) {
      const target = row || this.currentRow;
      if (!target) {
        this.$message.error("请先选择要删除的数据");
        return;
      }
      this.$confirm("确认删除该教研组吗?", "提示", { type: "warning" }).then(() => {
        this.listLoading = true;
        deleteTeachingGroup({ id: target.Id }).then(res => {
          if (res.success) {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(res.msg || "删除失败");
          }
        }).finally(() => {
          this.listLoading = false;
        });
      });
    },
    // 提交表单
    submitForm() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          const postData = {
            ...this.editForm,
            StartTime: this.editForm.dateRange[0],
            EndTime: this.editForm.dateRange[1],
            SchoolId: this.SchoolId
          };
          saveTeachingGroup(postData)
            .then(res => {
              if (res.success) {
                const tip = res.msg || "保存成功";
                if (Number(postData.Id) > 0) {
                  this.$message({ type: "success", duration: 5000, message: tip });
                } else {
                  this.$message.success(tip);
                }
                this.dialogVisible = false;
                this.getList();
              } else {
                this.$message.error(res.msg || "保存失败");
              }
            })
            .finally(() => {
              this.submitLoading = false;
            });
        }
      });
    },
    resetForm() {
      this.$refs.editForm.resetFields();
    },
    // 分页
    handleSizeChange(val) {
      this.filters.PageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.filters.Page = val;
      this.getList();
    },
    // 部门树点击回调
    handleNodeClick(node) {
      this.SchoolId = node.value;
      this.filters.Page = 1;

      // 彻底清空工具栏搜索条件（UI 状态 + 内部模型）
      if (this.$refs.toolbar) {
        this.filters.Keyword = "";
        this.filters.Status = null;

        this.$refs.toolbar.searchObj = {
          Keyword: "",
          Status: null
        };
      } else {
        this.filters.Keyword = "";
        this.filters.Status = null;
      }

      this.currentRow = null; // 切换学校时重置选中行
      this.loadTeachers(this.SchoolId); // 加载该校教师
      this.getList();
    }
  },
  mounted() {
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
};
</script>

<style scoped>
.tg-page {
  --tg-primary: #1e3a8a;
  --tg-bg: #eff6ff;
  --tg-muted: #64748b;
}
.tg-page .dp-right {
  background:
    radial-gradient(900px 220px at 0% 0%, rgba(59, 130, 246, 0.1), transparent 55%),
    #f8fafc;
  padding: 12px 14px 20px;
}
.tg-hero {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 12px;
}
.tg-eyebrow {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: var(--tg-primary);
  text-transform: uppercase;
}
.tg-title {
  margin: 0;
  font-size: 22px;
  font-weight: 750;
  color: #0f172a;
  letter-spacing: -0.02em;
}
.tg-sub {
  margin: 6px 0 0;
  font-size: 13px;
  color: var(--tg-muted);
}
.tg-hero__stat {
  padding: 10px 16px;
  background: #fff;
  border: 1px solid #dbeafe;
  border-radius: 12px;
  text-align: center;
  min-width: 88px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.tg-hero__stat span {
  display: block;
  width: 100%;
  font-size: 11px;
  color: var(--tg-muted);
  text-align: center;
}
.tg-hero__stat strong {
  display: block;
  width: 100%;
  font-size: 22px;
  color: var(--tg-primary);
  font-weight: 750;
  text-align: center;
}
.tg-panel {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 10px 12px 12px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  /* 列表吃满剩余高度。最后更新：2026-08-31 */
  flex: 1 1 auto;
  min-height: 0;
  height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.tg-panel .tbl-scroll-host {
  flex: 1 1 auto;
  min-height: 0;
  height: 0;
  width: 100%;
  overflow: hidden;
}
.tg-panel .tbl-scroll-host > .el-table {
  width: 100%;
  height: 100%;
}
.tg-table /deep/ .has-gutter .el-checkbox {
  display: none;
}
.tg-table /deep/ .el-table__header th {
  background: #f8fafc !important;
  color: #475569;
  font-weight: 700;
}
.tg-table /deep/ .el-table__row:hover > td {
  background: #eff6ff !important;
}
.tg-name {
  font-weight: 650;
  color: #0f172a;
}
.tg-count {
  display: inline-block;
  min-width: 22px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--tg-bg);
  color: var(--tg-primary);
  font-weight: 700;
  font-size: 12px;
}
.tg-threshold {
  font-weight: 650;
  color: var(--tg-primary);
}
.tg-unit {
  font-size: 12px;
  color: #94a3b8;
  margin-left: 2px;
}
.tg-link {
  color: #3b82f6 !important;
  font-weight: 600;
}
.is-danger {
  color: #dc2626 !important;
}
.tg-pager {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}
.tg-btn-primary {
  background: var(--tg-primary) !important;
  border-color: var(--tg-primary) !important;
}
.form-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  margin-top: 4px;
  display: flex;
  align-items: center;
}
.form-tip i {
  margin-right: 4px;
  font-size: 14px;
}
.form-hint {
  font-size: 12px;
  color: #909399;
  margin-left: 8px;
}
.text-gray {
  color: #909399;
  font-style: italic;
}
.multi-teacher-tag {
  color: var(--tg-primary);
  cursor: pointer;
  font-weight: 500;
}
.multi-teacher-tag:hover {
  text-decoration: underline;
}
.multi-teacher-tag .el-icon-view {
  margin-left: 2px;
  font-size: 12px;
}
.tg-teacher-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 360px;
  overflow-y: auto;
  padding: 4px 2px;
}
.tg-teacher-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 6px;
  background: #eff6ff;
  border: 1px solid #dbeafe;
  color: #1e3a8a;
  font-size: 13px;
  line-height: 1.4;
}
.tg-dialog-title {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding-right: 28px;
}
.tg-dialog-title__mark {
  width: 4px;
  height: 34px;
  margin-top: 2px;
  border-radius: 4px;
  background: linear-gradient(180deg, #1e3a8a, #3b82f6);
  flex-shrink: 0;
}
.tg-dialog-title__main {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}
.tg-dialog-title__sub {
  margin-top: 2px;
  font-size: 12px;
  color: #94a3b8;
  font-weight: 400;
}
</style>

<style>
.el-dialog.tg-catalog-dialog {
  border-radius: 14px !important;
  overflow: hidden !important;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.14) !important;
}
.el-dialog.tg-catalog-dialog .el-dialog__header {
  padding: 14px 18px 12px !important;
  border-bottom: 1px solid #e2e8f0 !important;
  background: #fff !important;
}
.el-dialog.tg-catalog-dialog .el-dialog__body {
  overflow: hidden !important;
  padding: 12px 16px 16px !important;
  background: #fff !important;
}
.el-dialog.tg-edit-dialog {
  border-radius: 14px !important;
}
.el-dialog.tg-edit-dialog .el-dialog__header {
  border-bottom: 1px solid #f1f5f9;
}
</style>
